import { Injectable } from '@angular/core';

export interface ItemTag {
    display: string,
    normalised: string,
    startPos: number,
    endPos: number
}

@Injectable()
export class TagParser {

    private regexp : RegExp = /#([^\s,.;:'"`#]+)/g;

    constructor() {}

    public parse(text : string) : ItemTag[] {
        var tags : ItemTag[] = [];
        for (var res = this.regexp.exec(text); res !== null; res = this.regexp.exec(text)) {
            var tagNoHash = res[1];
            tags.push({
                display: tagNoHash,
                normalised: this.normaliseTag(tagNoHash),
                startPos: res.index,
                endPos: res.index + res[0].length,
            });
        }
        return tags;
    }

    public normaliseTag(tag : string) : string {
        return tag.toLowerCase();
    }

}



// WEBPACK FOOTER //
// /Users/vlad/Projects/done/web/src/app/tags/tag-parser.service.ts